import { Button } from "primereact/button";

const exportToCsv = (users) => {
  const headers = ["Emaid", "Name", "Email", "Permissions", "Type", "ID"];
  const rows = users.map((u) => [u.emaid, u.name, u.email, u.permissions, u.connection, u.id]);
  const csvContent = [headers, ...rows]
    .map((row) => row.map((cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`).join(","))
    .join("\n");
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "app-users.csv";
  link.click();
  URL.revokeObjectURL(url);
};

const ExportSearchResultsCSV = ({ dataRef }) => {
  return (
    <Button
      label="Export CSV"
      icon="pi pi-download"
      severity="secondary"
      onClick={() => dataRef.current?.length && exportToCsv(dataRef.current)}
    />
  );
};

export default ExportSearchResultsCSV;
